// extracted by mini-css-extract-plugin
export default {"contents":"RD-z","sectionHeading":"SD-z"};